import { z } from 'zod';

const guestSchema = z.object({
  title: z.string().trim().min(1, 'required'),
  firstName: z.string().trim().min(1, 'required'),
  lastName: z.string().trim().min(1, 'required'),
  gender: z.string().trim().min(1, 'required'),
  id: z.union([z.string(), z.number()]).optional(),
  externalSpaId: z.union([z.string(), z.number()]).nullable().optional(),
  loggedInUser: z.object({ id: z.number() }).optional(),
  selectedGuestId: z.string().optional(),
});

export const spaEntityFormSchema = z.object({
  date: z.string().min(1, 'required'),
  arrivalTime: z.object({
    startTime: z.string().min(1, 'required'),
    endTime: z.string().min(1, 'required'),
    startDateTime: z.string().min(1, 'required'),
    endDateTime: z.string().min(1, 'required'),
    price: z.any().optional(),
    discount: z.any().optional(),
  }),
  guests: z.array(guestSchema).min(1, 'required'),
  extras: z.record(z.string(), z.any()).optional(),
  notes: z.string().optional(),
});

export type SpaEntityFormValues = z.infer<typeof spaEntityFormSchema>;
